import { DateValue } from '@internationalized/date';
import {
  MoneyInput,
  PaymentMethod,
  ReceiveInvoiceItemInput,
  ReceiveInvoiceInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';
import { anyDateToISOString } from '~/shared/utils/dateTime';

export type ReceiveInvoiceItem = {
  invoiceId: string;
  appliedAmount: MoneyInput;
};

export type ReceiveInvoiceParams = {
  accountId?: string | null;
  invoices: ReceiveInvoiceItem[];
  paymentMethod: PaymentMethod;
  financialAccountId: string;
  transactionDate: DateValue;
  checkFacilityId?: string | null;
  checkNumber?: string | null;
  checkMemo?: string | null;
  achNumber?: string | null;
  wireNumber?: string | null;
};

export const receiveInvoiceAtom = createMutationAtomFactory(
  'finance.receiveInvoice',
  (params: ReceiveInvoiceParams) => {
    const invoices: ReceiveInvoiceItemInput[] = params.invoices.map((inv) => ({
      invoiceId: inv.invoiceId,
      appliedAmount: inv.appliedAmount,
    }));

    const input: ReceiveInvoiceInput = {
      invoices,
      financialAccountId: params.financialAccountId,
      paymentMethod: params.paymentMethod,
      transactionDate: anyDateToISOString(params.transactionDate) ?? '',
    };

    if (params.accountId) {
      input.accountId = params.accountId;
    }
    if (params.checkFacilityId) {
      input.checkFacilityId = params.checkFacilityId;
    }
    if (params.checkNumber) {
      input.checkNumber = params.checkNumber;
    }
    if (params.checkMemo) {
      input.checkMemo = params.checkMemo;
    }
    if (params.achNumber) {
      input.achNumber = params.achNumber;
    }
    if (params.wireNumber) {
      input.wireNumber = params.wireNumber;
    }

    return {
      financeReceiveInvoice: {
        __args: {
          input,
        },
        payment: {
          id: true,
          documentNumber: true,
          status: true,
          amount: {
            amount: true,
            currencyCode: true,
          },
          paymentMethod: true,
          transactionDate: true,
          timestamps: {
            createdAt: true,
            updatedAt: true,
          },
        },
        belowWarningThreshold: true,
      },
    };
  },
);
